import {IVendorNames, IVendor} from '../types/payment';
import {vendorData} from '../pages/cashout/withdrawal/data';
import {IWithdrawalCreated, IWithdrawalLink} from '../types/payment';
import api from 'services/axios';
import {API_ROUTES} from '../constants';

// todo: in the future, we might want to get this data from the server
export const getVendorsData = async (): Promise<Record<IVendorNames, IVendor>> => {
    return vendorData;
};

// Issue a new withdrawal in vendor
export const createWithdrawal = async (vendor: string, amount: number, email?: string): Promise<IWithdrawalCreated> => {
  // Construct the payload for the API request
  const payload = {
    "vendor": vendor,
    "amount": amount,
    "email": email || null, // Optional field, currently used for PayPal only
  };
  
  const response = await api.post(API_ROUTES.CASHOUT.CREATE_WITHDRAWAL, payload);
  return response?.data;
}

// Get the withdrawal link by withdrawal ID, will create a new link in backend
export const getWithdrawalLink = async (withdrawal_id: string): Promise<IWithdrawalLink> => {
  const response = await api.get(API_ROUTES.CASHOUT.GET_WITHDRAWAL_LINK + `/${withdrawal_id}`);
  // Return the link from the response data
  return response?.data;
}
